import { create } from 'zustand'

export const useSessionStore = create((set) => ({
  isSessionExpired: false,
  setSessionExpired: (value) => set({ isSessionExpired: value }),
}))